import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Calendar, Timer, MessageSquare, CalendarOff } from 'lucide-react';

const tabs = [
  { name: 'Home', href: '/dashboard', icon: LayoutDashboard },
  { name: 'Schedule', href: '/schedule', icon: Calendar },
  { name: 'Time', href: '/time-tracking', icon: Timer },
  { name: 'Chat', href: '/chat', icon: MessageSquare },
  { name: 'Time Off', href: '/time-off-requests', icon: CalendarOff },
];

export const MobileBottomNav = () => {
  const location = useLocation();

  return (
    <nav className="mobile-bottom-nav md:hidden" data-testid="mobile-bottom-nav">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.href;
        return (
          <Link
            key={tab.name}
            to={tab.href}
            data-testid={`bottom-nav-${tab.name.toLowerCase().replace(' ', '-')}`}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-2 min-h-[56px] transition-colors ${
              isActive ? 'text-primary' : 'text-slate-400 active:text-slate-200'
            }`}
          >
            <tab.icon className="w-5 h-5" />
            <span className="text-[10px] font-medium leading-tight">{tab.name}</span>
          </Link>
        );
      })}
    </nav>
  );
};
